import { Component, Input } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
// @ts-ignore
import _ from "lodash";
import { AlertService } from "src/app/services/alert.service";
import { AuthService } from "src/app/services/auth.service";
import { LoaderService } from "src/app/services/loader.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialog/confirm-dialog/confirm-dialog.component";
import { LivecoAPIService } from "src/app/services/liveco-api.service";

import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from "src/app/services/notifications.service";
import { ProofreadingService } from "src/app/services/proofreading.service";
import { InternStateName } from "src/app/models/states.model";
import { StateMachineService } from "src/app/services/machine-state.service";
import { FlowType, Proofreading } from "src/app/models/proofreading.model";
import { ProjectService } from "src/app/services/project.service";
import { MembersService } from "src/app/services/member.service";
import { ViewComponent } from "src/app/shared/pages/view/view.component";
import { ChildProject, IChildProject } from "src/app/models/projects/project.model";
import { ProofreadingHistoryService } from "src/app/services/proofreading-history.service";
import { firstValueFrom } from "rxjs";
import { CLIENT_CONFIG } from "src/config";

@Component({
    selector: "app-proofreading-info",
    templateUrl: "./proofreading-info.component.html",
    styleUrls: ["./proofreading-info.component.scss"],
    // encapsulation: ViewEncapsulation.None
})
export class ProofreadingInfoComponent extends ViewComponent {

    @Input() type: 'intern' | 'extern' | 'revisions' = 'extern';

    // PROJECT 
    get project(): ChildProject | undefined {
        return this.s_projects.current as any;
    }
    get identifier(): string {
        return this.project?.identifier || '';
    };
    get id_maitre(): string {
        return this.project?.id_maitre || '';
    };
    get description(): string {
        return this.project?.description || '';
    };
    get codeArticle(): string {
        return this.project?.custom.general?.id_codearticle || '';
    };
    get codeArticleInfo(): string {
        return this.project?.custom.general?.designation || '';
    };
    get projectID(): string {
        return this.proofreading?.project.ID || '';
    }

    get isOldProject(): boolean {
        return this.project?.custom?.general?.is_old || false;
    }

    // PROOFREADING
    get proofreading(): Proofreading | undefined {
        return this.s_proofreadings.current;
    }

    get flow(): FlowType {
        return this.proofreading?.flow || FlowType.EXE;
    }

    get has_view() {
        return (this.type === 'revisions' && !!this.revision_url) || (this.type === 'intern' && !!this.urlPackZ) || (this.type === 'extern' && !!this.proofreading?.file_url);
    }

    get urlPackZ(): string | undefined {
        return this.proofreading?.intern?.viewer.file_url;
    }

    get formated_relecture() {
        return this.proofreading?.flow === FlowType.REPRO ? `V${this.current_relecture}` : `R${this.current_relecture}`;
    }
    get formated_version() {
        return `v${this.current_version}`;
    }

    get current_version() {
        return this.proofreading?.intern?.viewer.version;
    }

    get current_relecture() {
        return this.proofreading?.relecture || 1;
    }

    get INTERN_STATE_NAME() {
        return InternStateName;
    }

    get typesUser() {
        return this.s_auth.user?.attributes_name || [];
    }

    get current_member() {
        return this.s_members.current_member;
    }

    get revision_url() {
        return this.s_proofreadingHistories.compare.intern.url.value || this.s_proofreadingHistories.compare.approval.url.value;
    }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected dialog: MatDialog,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected title: Title,
        protected liveco: LivecoAPIService,
        protected notifications: NotificationsService,
        protected s_sm: StateMachineService,
        public s_proofreadings: ProofreadingService,
        protected s_proofreadingHistories: ProofreadingHistoryService,
        protected s_projects: ProjectService,
        protected s_members: MembersService,
        protected translate: TranslateService
    ) {
        super(route, router, s_alert, s_loader, s_auth);
        // super(title, route, router, s_alert, s_loader, s_auth, liveco, s_sm, s_proofreadings, s_projects, s_members, sanitizer);
    }

    // Admin users can reset prod
    async resetProdAdmin() {
        const res = await firstValueFrom(this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: `RESET_PROD.TITLE`,
                text: `RESET_PROD.TEXT`,
                valid: 'YES'
            }
        }).afterClosed());
        if (res) {
            this.s_loader.loading = true;
            const reply = await this.liveco.create('/admin/reset-intern', { proofreadingID: this.proofreading?._id });
            this.s_proofreadings.emitCurrent(new Proofreading(reply));
        }
    }

    goToHome() {
        this.router.navigate(["/"]);
    }

    async refreshViewUrl() {
        if (this.type === 'intern') {
            this.s_proofreadings.view_links.intern.next(null);
            await this.s_proofreadings.patchCurrent({ 'intern.viewer.file_url': this.proofreading?.intern?.viewer.file_url }, { refreshView: true});
        } else {
            this.s_proofreadings.view_links.extern.next(null);
            await this.s_proofreadings.patchCurrent({ 'file_url': this.proofreading?.file_url }, { refreshView: true});
        }
    }

    openInNewTab(route: string[]): void {
        const url = this.router.serializeUrl(this.router.createUrlTree([...route])).replace(/^\/%23\//g, '/#/');
        window.open(url, '_blank');
    }

    openFileInPackZ() {
        if (this.urlPackZ)
            this.s_projects.openFileInPackZ(this.urlPackZ);
    }

    openFolderChild() {
        if (this.project)
            this.s_projects.openFolderChild(this.project);
    }

    toggleIFrameFullScreen() {
        const iframe = document.getElementsByTagName('iframe')[0] as HTMLIFrameElement;
        console.log('iframe', iframe);
        iframe.parentElement?.classList.add('splitview-fullscreen');

        this.subscription.add(document.addEventListener('keydown', e => e.key === 'Escape' && document.dispatchEvent(new Event('exit-fullscreen'))));
    }

    getColorFlow(flow:FlowType): string {
       return CLIENT_CONFIG.getFlowConfig(flow).style.bg_color;
    }
}
